export const AuthStatus = {
  LOADING: "loading",
  AUTHENTICATED: "authenticated",
  UNAUTHENTICATED: "unauthenticated",
} as const;
export type AuthStatus = (typeof AuthStatus)[keyof typeof AuthStatus];

export const PROVIDER_LABEL: Record<string, string> = {
  google: "Google",
  apple: "Apple",
  kakao: "Kakao",
};
export type ProviderLabel = (typeof PROVIDER_LABEL)[keyof typeof PROVIDER_LABEL];

export const TestStatus = {
  COMPLETED: "completed",
  IN_PROGRESS: "in_progress",
  PENDING: "pending",
} as const;
export type TestStatus = (typeof TestStatus)[keyof typeof TestStatus];

export const StatusLabel: Record<TestStatus, string> = {
  [TestStatus.COMPLETED]: "완료",
  [TestStatus.IN_PROGRESS]: "진행중",
  [TestStatus.PENDING]: "미제출",
};

export const COUNTDOWN_OPTIONS = [3, 5, 10] as const;
export type CountdownOption = (typeof COUNTDOWN_OPTIONS)[number];

export const TARGET_SCORE_OPTIONS = [90, 95, 98] as const;
export type TargetScoreOption = (typeof TARGET_SCORE_OPTIONS)[number];

export const EXAM_QUESTION_COUNT_OPTIONS = [100, 300, 500] as const;
export type ExamQuestionCountOption = (typeof EXAM_QUESTION_COUNT_OPTIONS)[number];

/** 신규 테스트 기본 문항 수 — 완주율 개선을 위해 100으로 시작 */
export const DEFAULT_EXAM_QUESTION_COUNT: ExamQuestionCountOption = 100;

export const FLASHCARD_SESSION_SIZE_OPTIONS = [50, 100, 300, "all"] as const;
export type FlashcardSessionSize = (typeof FLASHCARD_SESSION_SIZE_OPTIONS)[number];
export const DEFAULT_FLASHCARD_SESSION_SIZE: FlashcardSessionSize = 100;

export const TestPhase = {
  TEST: "test",
  REPORT: "report",
} as const;
export type TestPhase = (typeof TestPhase)[keyof typeof TestPhase];

export const ReportTab = {
  CARD: "card",
  NOTE: "note",
} as const;
export type ReportTab = (typeof ReportTab)[keyof typeof ReportTab];

/** 무료 유저가 Review Note를 열람할 수 있는 최대 경과일 */
export const FREE_REVIEW_NOTE_DAYS = 3;

export const FlashcardCategory = {
  LEARNING: "learning",
  KNOWN: "known",
} as const;
export type FlashcardCategory = (typeof FlashcardCategory)[keyof typeof FlashcardCategory];

export const Language = {
  ENGLISH: "english",
  KOREAN: "korean",
} as const;
export type Language = (typeof Language)[keyof typeof Language];

export const LanguageLabel: Record<Language, string> = {
  [Language.ENGLISH]: "영어",
  [Language.KOREAN]: "한국어",
} as const;
export type LanguageLabel = (typeof LanguageLabel)[keyof typeof LanguageLabel];

export const Direction = {
  LEFT: "left",
  RIGHT: "right",
} as const;
export type Direction = (typeof Direction)[keyof typeof Direction];

export const DEFAULT_NOTIFICATION_SETTINGS = {
  enabled: true,
  daily_reminder: true,
  daily_reminder_time: "09:00",
  incomplete_test: true,
  wrong_answer_review: true,
  wrong_answer_timing: "next_morning",
  streak_reminder: false,
} as const;
